export const ACCOUNT_NICKNAMES_CONTAINER_TAG_NAME = 'account-nicknames-container';
